/* template */
<template><div><error-page :errno="(pageErrno)" :useGoodsNotExistError="(true)" v-if="(pageErrno)"/><div :style="(pageStyle)" class="page page-detail" v-else><template v-for="(item, index) in (MallRenderData.components)"><component :is="(item.name)" :mall-data="(item.data)" @mall-page-event="$_onMallPageEvent" v-if="(!item.hide)"/></template></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m70860bc5"}'>
.page-detail
  overflow-x hidden
// .page
//   background-color #fcfdfe
@css {
  .page-detail {
    padding-bottom: 253rpx;
  }
  @supports (padding-bottom: constant(safe-area-inset-bottom)) {
    .page-detail {
      padding-bottom: calc(constant(safe-area-inset-bottom) + 253rpx);
    }
  }
  @supports (padding-bottom: env(safe-area-inset-bottom)) {
    .page-detail {
      padding-bottom: calc(env(safe-area-inset-bottom) + 253rpx);
    }
  }
}

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createPage } from '@mpxjs/core'
import { GlobalEnv, URLQueries, PageDetailMixin, mallTrackStd, navigateTo } from '../../lib/webx'
import { EnumGoodsDetailIsSpike } from '../../lib/webx/defines/enums'
import { BogoMixin } from './activity_mixins/bogo'
import { RightMixin } from './activity_mixins/right'
import { is, login, logout, utils, xenv } from '@didi/webx-js'
import { MASErrorTrackCreateOrderFailed } from '../../lib/webx/mas_error_track'
import { TechPageInGoodsDetailOld } from '../../lib/webx/tech_error_track'
import { isSoldOut } from '../../lib/webx/mpx/mixins/page_detail/judge'

const PageConfig = {
  needApollo: true,
  title: '',
  hooks: {
    afterGetDetail(goods) {
      if (__mpx_mode__ === 'web') {
        document.getElementById('loading')?.remove()
      }
      const _isSoldOut = isSoldOut(goods)?.soldOut
      if (_isSoldOut || goods.endTime < goods.currentTime) {
        this.collapseDetail.status = true
      }
      const trackParams = {
        package_id: goods.goodId,
        package_type: goods.isSpike,
        g_BizId: goods.productType,
        package_species: goods.cateId,
        show_moudle: goods.showVersion,
        is_share: goods.isSpike === EnumGoodsDetailIsSpike.Bogo &&
          goods.shareCouponInfo.purchaseCount > 0 &&
          goods.shareCouponInfo.shareLeft > 0,
        route_type: goods.routeType,
      }
      if (goods.routeType) {
        trackParams.is_fillstart = goods.startingName ? 1 : 0
        trackParams.is_fillend = goods.destName ? 1 : 0
      }
      if (GlobalEnv.isTrackCityId) {
        trackParams.omg_city_id = GlobalEnv.locationInfo?.cityId
      }
      mallTrackStd('wyc_trippackage_homepage_sw', '套餐买一赠N未购买页面曝光', trackParams)
    },
    beforeRender(mallRenderData) {
      if (this.blockRender) {
        return {
          ...mallRenderData,
          components: [],
        }
      }
      mallRenderData.components.push({
        name: 'pay-result',
        hide: true,
        data: {
          isPassCard: false,
          code: null,
          payExtra: this.$data.$_.payExtra,
          isFree: false,
          orderId: '',
          productType: this.$data.$_.goods.productType,
          cardShow: this.$data.$_.goods.cardShow,
        },
      })
      if (this.$data.$_.goods.isCashback) {
        const index = mallRenderData.components.findIndex(component => component.name === 'price-bar')
        if (index > -1) {
          mallRenderData.components.splice(index + 1, 0, {
            name: 'cashback-condition',
            data: {
              days: this.$data.$_.goods.lifeDays,
            },
          })
        }
      }
      // 快升专不要这个
      if (this.collapseDetail.status && mallRenderData.template !== 'right') {
        this.collapseDetail.allComponents = mallRenderData.components
        this.collapseDetail.collapseComponents = this.collapseDetail.allComponents
          .filter(component => [ 'top-header', 'recommend-list', 'operations' ].indexOf(component.name) > -1)
        this.collapseDetail.collapseComponents.splice(2, 0, {
          name: 'collapse-detail-btn',
        })
        return {
          ...mallRenderData,
          components: this.collapseDetail.collapseComponents,
        }
      }
      return mallRenderData
    },
    async beforeOrder() {
      if (URLQueries.getQuery('origin') === 'juejin' && __mpx_mode__ === 'web') {
        const res = await mpx.showModal({
          content: `确认购买套餐到该手机号:${GlobalEnv.loginInfo.phone}`,
          confirmText: '确认购买',
          cancelText: is('miniprogram') ? '取消' : '重新登录',
        })
        switch (true) {
          case res.confirm:
            return Promise.resolve()
          case res.cancel:
            if(is('miniprogram')) {
              Promise.reject()
            } else {
              logout().then(res => {
                login().then(res => {
                  window.location.reload()
                })

              }).catch(() => {
                login().then(res => {
                  window.location.reload()
                })
              })
            }
        }
      } else {
        return Promise.resolve()
      }
    },
    async afterOrder({ errno, orderId, error, orderBySpike, groupId }) {
      if (errno !== undefined && errno !== 0) {
        if (window.Omega) {
          let msg = '没有错误 Message.'
          if (typeof error === 'string') { msg = error }
          if (error.message) { msg = error.message }
          if (error.msg) { msg = error.msg }
          MASErrorTrackCreateOrderFailed(msg, {
            source: 'goodsdetail',
            orderId,
            error,
          })
        }
      }
      if (__mpx_mode__ === 'web' && is('miniprogram')) return
      // code 9109, 用户支付超时，发生在端外浏览器上的场景多
      if ( error?.code === 9109 && ![ 'passenger', 'hypassenger' ].includes(xenv())) return
      if (orderBySpike === EnumGoodsDetailIsSpike.Group) {
        navigateTo('goodsProcess', {
          groupId: groupId,
          orderId: orderId,
          prev: 'groupGoodsDetail',
        })
        return
      }
      const component = this.MallRenderData.components
        .find(component => component.name === 'pay-result')
      component.data.code = errno ? 3 : 1
      component.data.payExtra = this.$data.$_.payExtra
      component.data.isFree = this.$data.$_.goods.price === 0
      component.data.orderId = orderId
      component.hide = false
    },
  },
}

createPage({
  mixins: [ RightMixin(PageConfig), BogoMixin(PageConfig),  PageDetailMixin(PageConfig) ],
  data: {
    collapseDetail: {
      status: false,
      allComponents: [],
      collapseComponents: [],
    },
    blockRender: false,
    bottomTimer: null,
    GlobalEnv,
  },
  onReachBottom() {
    if (is('miniprogram') && is('iphone')) {
      const dom = document.querySelector('.mall-operations')
      if (dom) {
        const parent = dom.parentNode
        this.bottomTimer = setInterval(() => {
          parent.removeChild(dom)
          parent.appendChild(dom)
        }, 1000)
      }
    }
  },
  methods: {
    closePayResult() {
      const component = this.MallRenderData.components
        .find(component => component.name === 'pay-result')
      component.hide = true
      component.data.code = null
    },
    openCollapseDetail() {
      this.MallRenderData.components = this.collapseDetail.allComponents
    },
    redirectToOldDetail() {
      // const url = window.location.href.replace('goodsDetail.html', 'goodsDetailOld.html')
      // window.location.replace(url)
      mpx.showModal({
        content: '商品详情页目前只支持商品类型为：套餐卡、商家券套餐、金融套餐的商品展示，其他类型商品暂不支持',
        confirmText: '确定',
        showCancel: false,
      })
      TechPageInGoodsDetailOld()
    },
    redirectToSpikeDetail() {
      const url = window.location.href.replace('goodsDetail.html', 'spikeDetail.html')
      window.location.replace(url)
    },
    showRoutePop(data) {
      const component = this.MallRenderData.components.find(
        component => component.name === 'route-pop'
      )
      data.pageType = 2
      if (!component) {
        this.MallRenderData.components.push({
          name: 'route-pop',
          hide: false,
          data,
        })
      } else {
        component.data = data
        component.hide = false
      }
    },
    hideRoutePop(routeFromPop) {
      const component = this.MallRenderData.components
        .find(component => component.name === 'route-pop')
      component.hide = true
      component.data.code = null

      // 更新按钮区
      const optionsComp = this.MallRenderData.components
        .find(component => component.name === 'operations')
      if (optionsComp) {
        Object.assign(optionsComp.data, {
          routeFromPop: typeof routeFromPop === 'boolean' ? routeFromPop : false,
        })
      }

    },
  },
  computed: {
  },
  onUnload() {
    utils.resetFontSize()
    this.bottomTimer && clearInterval(this.bottomTimer)
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'rules':getComponent(require("../../components/goods_detail/rules.mpx?component=true&componentId=rules8abb0012")),'group-rules':getComponent(require("../../components/goods_detail/group-rules.mpx?component=true&componentId=group-rules31053769")),'conditions':getComponent(require("../../components/goods_detail/conditions.mpx?component=true&componentId=conditions8071a734")),'supplementar':getComponent(require("../../components/goods_detail/supplementar.mpx?component=true&componentId=supplementar010d8998")),'city-info':getComponent(require("../../components/goods_detail/city-info.mpx?component=true&componentId=city-infod53d1460")),'recommend-list':getComponent(require("../../components/goods_detail/recommend-list.mpx?component=true&componentId=recommend-list118fbdbd")),'pay-result':()=>import("../../components/goods_detail/pay-result.mpx?async=pay-result&component=true&componentId=pay-result987074e0").then(res => getComponent(res)),'route-pop':()=>import("../../components/goods_detail/route-pop.mpx?async=route-pop&component=true&componentId=route-pop1c16244d").then(res => getComponent(res)),'right-main':()=>import("../../components/goods_detail/right/right-main.mpx?async=right-main&component=true&componentId=right-mainea8662ea").then(res => getComponent(res)),'route-box':()=>import("../../components/common/route-box.mpx?async=route-box&component=true&componentId=route-box7d9da418").then(res => getComponent(res)),'error-page':()=>import("../../components/common/error-page.mpx?async=error-page&component=true&componentId=error-pagebda7909e").then(res => getComponent(res)),'collapse-detail-btn':()=>import("../../components/goods_detail/collapse-detail-btn.mpx?async=collapse-detail-btn&component=true&componentId=collapse-detail-btn3945d7c0").then(res => getComponent(res)),'n-coupon-packages':()=>import("../../components/goods_detail/n-order/coupon-package/index.mpx?async=n-coupon-packages&component=true&componentId=index789003a0").then(res => getComponent(res)),'coupon-packages-list':getComponent(require("../../components/goods_detail/coupon-packages-list/index.mpx?component=true&componentId=index14f180f0")),'top-header':getComponent(require("../../components/goods_detail/header/index.mpx?component=true&componentId=indexfc854284")),'operations':getComponent(require("../../components/goods_detail/operations/index.mpx?component=true&componentId=index945f8446")),'right-operations':()=>import("../../components/goods_detail/right/operations/index.mpx?async=right-operations&component=true&componentId=index35dc3eb0").then(res => getComponent(res))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
